<template>
  <div class="home-wrapper">
    <Header />
    <div class="main__content">
      <SideBar />
      <main class="main" :class="{ sideBarClosed: isToggleSideBar }">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import SideBar from '@/components/SideBar/SideBar.vue'

export default {
  components: {
    Header,
    SideBar
  },
  computed: {
    isToggleSideBar() {
      return this.$store.state.toggleSideBar
    }
  }
}
</script>
